import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { ChastiaCreateRevisionPayload } from 'api/actions/chastia-create-revision/chastia-create-revision-payload';
import { ChastiaCreateRevisionPathParameters } from 'api/actions/chastia-create-revision/chastia-create-revision-path-parameters';
import { ChastiaCreateRevisionResponse } from 'api/actions/chastia-create-revision/chastia-create-revision-response';

type ChastiaCreateRevisionQueryParameters = Record<string, any>;

/**
 * The path of the ChastiaCreateRevision action.
 */
export const chastiaCreateRevisionActionPath = new SweetPath<keyof ChastiaCreateRevisionPathParameters>(
  '/api/chastia/revision',
  { path: '{param}' }
);

/**
 * Creates a contextualized ChastiaCreateRevision actions.
 */
export default function createChastiaCreateRevisionAction(axios: AxiosInstance) {
  return function chastiaCreateRevisionAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: ChastiaCreateRevisionQueryParameters;
    payload: ChastiaCreateRevisionPayload;
  }) {
    const path = chastiaCreateRevisionActionPath.original;

    return axios.request<ChastiaCreateRevisionResponse, ChastiaCreateRevisionResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
